module.exports = __webpack_public_path__ + "static/media/Rectangle 409.75a27bb3.png";